"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.E2E_TESTS_FEATURE_FLAGS_CYPRESS = exports.E2E_TESTS_FEATURE_FLAGS = void 0;
exports.E2E_TESTS_FEATURE_FLAGS = [
    "_editor landing page builder",
    "_editor media library",
    "_editor new data integration flow",
    "_editor publish to channels",
    "_editor start from story templates gallery",
    "accountOwnerUserManagement",
    "adsStoryVideoRatioQualityDefinition",
    "analyticsDataSources",
    "campaignSettings",
    "creative",
    "crmStoryVideoRatioQualityLogic",
    "deleteContentSet",
    "deleteUserInUserManagement",
    "overviewWithoutCampaignSettingsTab",
    "overviewWithoutOverviewTab",
    "recordingDocs",
    "sceneOrderInStories",
    "showHideColumnsInStoryMap",
    "storyLogic"
];
exports.E2E_TESTS_FEATURE_FLAGS_CYPRESS = [
    "_editor review and comment",
    "_editor create accounts db program"
];
//# sourceMappingURL=e2eTestConsts.js.map